import styled from 'styled-components'

export default styled.div`
  overflow-y: auto;
  height: ${document.body.clientHeight - 52}px;
  padding-left: 18px;
  padding-right: 18px;

  h4 {
    text-align: center;
    margin-top: 43px;
    font-size: 20px;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    margin-bottom: 23px;
  }

  h5 {
    text-align: center;
    font-size: 12px;
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    margin-bottom: 40px;
  }

  .input-container {
    &.phone {
      display: flex;
    }
  }
  .input-field {
    width: 100%;

    label > span {
      color: red;
    }

    label {
      color: #767676 !important;
    }

    div::after {
      border-color: #000 !important;
    }
  }
  .selector-container {
    margin-top: 20px;
  }
  label, input {
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
  }
  label {
    font-size: 12px;
  }
  input {
    font-size: 14px;
  }
  #required {
    font-size: 12px;
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    margin-top: 30px;

    span {
      color: red;
    }
  }
  #pics {
    display: flex
    font-family: 'ABChanel PB Regular L', Arial, sans-serif;
    margin-top: 51px;
    margin-bottom: 43px;

    .checkbox {
      border: 1px solid #000;
      width: 10px;
      height: 10px;
      margin-right: 11px;

      &.checked {
        background-color: #000;
      }
    }

    .pics_statement {
      font-size: 9px;
      width: 90%;
    }
  }
  .submit-btn {
    width: 100%;
    height: 50px;
    color: #ffffff;
    border-radius: 0 !important;
    border: none;
    background-color: #000000 !important;
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 12px !important;

    html[lang=tw] & {
      font-size: 14px !important;
    }

    &:disabled {
      background-color: #a3a3a3 !important;
    }

    .loader {
      width: 30px;
      height: 30px;
    }
  }
  .guest-checkout {
    font-family: 'ABChanel PB Regular M', Arial, sans-serif;
    font-size: 11px;
    margin-top: 51px;
    margin-bottom: 83px;
    text-align: center;

    div {
      display: inline-block;
      border-bottom: 1px solid #ececec;
      height: 23px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/InfoForm.js